import "./prasora-file-explorer.scss";
import m from "mithril";
import pf from "../../pf";
import svg from "../../svg";
import checkbox from "../raw-components/check-box/check-box";
import JSZipUtils from "../../lib/jszip-utils";
import JSZip from "jszip";
// import StreamToBlob from "stream-to-blob";

export default () => {
	let tid = null;
	let tact = null;
	let prid = null;
	let processing = true;
	let result = {};
	let pagenum = 1;
	let searchtext = null;
	let tempSearchText = null;
	let pagesize = 100;
	let rowcount = 0;
	let noOfPages = 0;
	let tempPageNumber = 1;
	let downloading = false;
	let percentDownload = 0;
	let msg = null;

	function urlToPromise(url, filename, filetype) {
		return new Promise(function (resolve, reject) {
			JSZipUtils.getBinaryContent(url, function (err, data) {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		});
	}

	async function DownloadSelectedFiles() {
		// console.log("about to start download");
		let filesSelected = result.rows.some((a) => a.selected);
		// console.log({result});
		if (filesSelected) {
			downloading = true;
			m.redraw();
			var zip = new JSZip();
			result.rows.forEach((r) => {
				if (r.selected && r.url.links) {
					r.url.links.forEach((l, li) => {
						var filename = `${r.name.text}${r.url.links.length > 1 ? `-${li + 1}` : ""}.${l.extension || "pdf"}`;
						console.log({filename, l, li});
						zip.file(filename, urlToPromise(l.url, filename, !!l.extension), {
							binary: true,
						});
					});
				}
			});

			// when everything has been downloaded, we can trigger the dl
			await zip
				.generateAsync(
					{
						type: "blob",
					},
					function updateCallback(metadata) {
						percentDownload = metadata.percent.toFixed(0);
						// console.log(percentDownload);
						m.redraw();
						if (metadata.currentFile) {
							msg = "downloading file: " + metadata.currentFile;
						}
					}
				)
				.then(
					function callback(blob) {
						downloading = false;
						msg = null;
						m.redraw();
						percentDownload = 0;
						m.redraw();
						saveAs(blob, "download.zip");
					},
					function (e) {}
				);
		} else {
			alert("No Files Selected");
		}
	}

	function PageIncrease() {
		PageImpact(1);
		DelayedRefresh();
	}

	function PageDecrease() {
		PageImpact(-1);
		DelayedRefresh();
	}

	function PageImpact(i) {
		pagenum += i;
		noOfPages = Math.ceil(rowcount / pagesize);
		if (pagenum > noOfPages) {
			pagenum = noOfPages;
		}
		if (pagenum < 1) pagenum = 1;
		tempPageNumber = pagenum;
	}

	function DirectSetPageNum() {
		if (tempPageNumber) {
			pagenum = tempPageNumber;
			noOfPages = Math.ceil(rowcount / pagesize);
			if (pagenum > noOfPages) {
				pagenum = noOfPages;
			}
			if (pagenum < 1) pagenum = 1;
			DelayedRefresh();
			tempPageNumber = pagenum;
		}
	}

	let timeout = null;

	function DelayedRefresh() {
		processing = true;
		if (timeout) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(function () {
			GetData();
		}, 800);
	}

	var searchXHR = null;

	function abortPreviousSearch() {
		if (searchXHR !== null) {
			searchXHR.abort();
		}
		searchXHR = null;
	}

	async function GetData() {
		abortPreviousSearch();

		await pf
			.APIAction(
				"GetDataForFileExplorer",
				{
					tid: tid,
					tact: tact,
					searchtext: searchtext,
					prid: prid,
					pagenum: pagenum,
					pagesize: pagesize,
				},
				function (xhr) {
					searchXHR = xhr;
				}
			)
			.then((r) => {
				// console.log(r);
				result = r;
				rowcount = r.rowcount;
				noOfPages = Math.ceil(rowcount / pagesize);
				processing = false;
				// console.log(result);
				m.redraw();
			});
	}

	return {
		oninit: (v) => {
			if (!JSZip.support.blob) {
				alert("This demo works only with a recent browser !");
				return;
			}
			tid = v.attrs.tid;
			tact = v.attrs.tact;
			prid = v.attrs.prid;
			GetData();
		},
		view: (v) => {
			return m(".prasora-file-explorer", [
				v.attrs.blocktitle && m(".section-header", v.attrs.blocktitle),
				processing
					? m("h2", "processing...")
					: m(".section-content", [
							m(".section-search-bar", [
								m("input", {
									value: tempSearchText,
									placeholder: "SEARCH",
									oninput: (e) => {
										tempSearchText = e.target.value;
									},
								}),
								m(
									"button",
									{
										type: "button",
										onclick: (e) => {
											searchtext = tempSearchText;
											DelayedRefresh();
										},
									},
									"Search"
								),
								m(
									"button",
									{
										type: "button",
										onclick: (e) => {
											searchtext = null;
											tempSearchText = null;
											DelayedRefresh();
										},
									},
									"Reset"
								),
							]),
							m(".section-file-list", [
								result.rows.map((r, ri) => {
									// console.log(r);

									if (r.url?.links?.some((l) => l.url)) {
										return m(
											".prasora-file-icon",
											{
												class: r.selected ? "selected" : "",
												onclick: (e) => {
													if (result.rows[ri].selected) result.rows[ri].selected = false;
													else result.rows[ri].selected = true;
													//   console.log(result.rows[ri].selected, ri);
												},
												ondblclick: (e) => {
													result.rows[ri].url.links.forEach((l, li) => {
														if (l.url) window.open(l.url, "_blank");
													});
												},
											},
											[
												m(svg, {
													name: "file-icon",
												}),
												m("span", r.name.text || "file" + ri),
											]
										);
									} else {
										return m(
											".prasora-file-icon",
											{
												class: "no-file",
												onclick: (e) => {
													alert("Sorry. No file uploaded.");
												},
											},
											[
												m(svg, {
													name: "no-file-icon",
												}),
												m("span", r.name.text || "file" + ri),
											]
										);
									}
								}),
							]),
					  ]),
				// downloading &&
				m(
					".section-progressbar",
					{
						class: downloading ? "show" : "hide",
					},
					[
						m("span", msg),
						m(".progress-bar-wrapper", [
							m(".progress-bar", {
								style: `--progress-bar-width: ${percentDownload}%;`,
							}),
						]),
					]
				),
				m(".section-footer", [
					m(".pagination-section", [
						m(
							"span.icon-btn",
							{
								onclick: PageDecrease,
								title: "Previous Page",
							},
							m(svg, {
								name: "arrow-left-circle",
							})
						),
						m("span.page-detail", [
							m("span.first-part", `Page `),
							m("input.current-page-number", {
								value: tempPageNumber,
								size: 1,
								oninput: (e) => {
									tempPageNumber = e.target.value;
									let t = e.target.value.match(/^-?\d*(\.\d+)?$/);
									if (t) {
										t = parseInt(e.target.value);
										if (t) tempPageNumber = t;
										DirectSetPageNum();
									}
								},
								onblur: (e) => {
									if (!tempPageNumber) tempPageNumber = pagenum;
								},
							}),
							m("span.second-part", ` of ${noOfPages} (${rowcount} records)`),
						]),
						m(
							"span.icon-btn",
							{
								onclick: PageIncrease,
								title: "Next Page",
							},
							m(svg, {
								name: "arrow-right-circle",
							})
						),
					]),

					m(
						checkbox,
						{
							onchange: (checked) => {
								result.rows.forEach((r) => {
									r.selected = checked;
								});
							},
						},
						["Select/Deselect All"]
					),

					m(
						"button",
						{
							type: "button",
							onclick: (e) => {
								DownloadSelectedFiles().then(() => {
									msg = "";
									percentDownload = 0;
								});
							},
						},
						"download"
					),
				]),
			]);
		},
	};
};
